document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash === "#program-select") {
    // Remove 'active' class from all .block__location-select elements
    document.querySelectorAll(".block__location-select.active").forEach(function (el) {
      el.classList.remove("active");
    });

    // Add 'active' class to #program-select
    var programSelect = document.getElementById("program-select");
    if (programSelect) {
      programSelect.classList.add("active");
    }
  }
});

function openProgramSelect() {
  document.querySelectorAll('.block__location-filter-item').forEach(function(el) {
      el.classList.remove('active');
  });
  document.getElementById('program-select').classList.add('active');
}
function openLocationSelect() {
  document.querySelectorAll('.block__location-filter-item').forEach(function(el) {
      el.classList.remove('active');
  });
  document.getElementById('location-select').classList.add('active');
}

// 
// const dateFilter = document.getElementById("dateFilter");

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".block__program-select-item").forEach(function (item) {
//       item.addEventListener("click", function () {
//         document.querySelectorAll('.block__location-filter-item').forEach(function(el) {
//             el.classList.remove('active');
//         });
//       document.getElementById('date-select').classList.add('active');

//       const dateValue = this.getAttribute("data-date").trim(); 
//       // Loop through options and hide non-matching ones, but skip the first
//       const options = Array.from(dateFilter.options);
//       options.forEach(function (opt, index) {
//         if (index === 0) return; // Skip first option
//         const optionValue = opt.value.trim(); 
//         if (optionValue.includes(dateValue)) {
//           opt.style.display = "block";   // show match
//         } else {
//           opt.style.display = "none";    // hide non-match
//         }
//       });

//       // Auto-select first matching option (skip first placeholder)
//       const firstMatch = options.find((opt, index) => index !== 0 && opt.style.display !== "none");
//       // if (firstMatch) firstMatch.selected = true;
//     });

//   });

//   // Listen for selecting an option
//   dateFilter.addEventListener("change", function () {
//     const selectedOption = this.options[this.selectedIndex];
//     if (!selectedOption || selectedOption.value === "Select date") return;
//     const selectedValue = selectedOption.value.trim();  // <<< USE VALUE
//     // FORMAT: "5 Days / Single / April 3 - 7"
//     const parts = selectedValue.split("/");
//     const days = parts[0].trim();
//     const dates = parts[parts.length - 1].trim(); // always last part
//     const encodedDays = days.replace(/ /g, "+");
//     const encodedDates = dates.replace(/ /g, "+");
//     const url = `https://reprecision.health/collections/rooms?filter.v.option.days=${encodedDays}&filter.v.option.dates=${encodedDates}`;
//     window.location.href = url;
//   });


// });
const dateFilter = document.getElementById("dateFilter");
const dateFilterList = document.getElementById("dateFilterbtn"); // <ul>
const dateItems = dateFilterList.querySelectorAll("li");

document.addEventListener("DOMContentLoaded", function () {

  // When clicking a program item → filter dates
  document.querySelectorAll(".block__program-select-item").forEach(function (item) {
    item.addEventListener("click", function () {
      
      // UI class reset (you had this already)
      document.querySelectorAll('.block__location-filter-item').forEach(function(el) {
        el.classList.remove('active');
      });
      document.getElementById('date-select').classList.add('active');

      // Filtering logic (same as for <select>, applied to <li>)
      const dateValue = this.getAttribute("data-date").trim();

      let firstMatch = null;

      dateItems.forEach(function (li) {
        const liValue = li.getAttribute("value").trim();

        if (liValue.includes(dateValue)) {
          li.style.display = "block";
          if (!firstMatch) firstMatch = li;
        } else {
          li.style.display = "none";
        }
      });

      // Auto-select first visible <li>
      if (firstMatch) {
        dateItems.forEach(li => li.classList.remove("active"));
        firstMatch.classList.add("active");
      }

    });
  });

  // Clicking a date <li> = selecting an option
  dateItems.forEach(function (li) {
    li.addEventListener("click", function () {

      const value = this.getAttribute("value").trim();
      if (!value || value === "Select date") return;

      const parts = value.split("/");
      const days = parts[0].trim();
      const dates = parts[parts.length - 1].trim();

      const encodedDays = days.replace(/ /g, "+");
      const encodedDates = dates.replace(/ /g, "+");

      const url = `https://reprecision.health/collections/rooms?filter.v.option.days=${encodedDays}&filter.v.option.dates=${encodedDates}`;

      window.location.href = url;
    });
  });

});
